import { ParamsHelper } from '../../helpers/ParamsHelper';
import { CommonHelper } from '../../helpers/CommonHelper';
import { ApiHttpService } from '../ApiHttpService';
import { PaymentTypeSerializer } from '../serializers/PaymentTypeSerializer';
import { PaymentType } from '../../models/PaymentType';

const PAYMENT_TYPE_PATH = 'usuario/TextosFormasDePagoPedido/';

class PaymentTypeController {
  static async all(purchaseType) {
    const authenticated = true;
    const parameters = ParamsHelper.createQueryParams({
      tipoCompra: purchaseType,
    });
    const response = await ApiHttpService.get(`${PAYMENT_TYPE_PATH}${parameters}`, {}, authenticated);
    const deSerializedData = CommonHelper
      .moveByIdToFirstPosition(response.data.map(PaymentTypeSerializer.deSerialize), 4);
    const paymentMethods = deSerializedData.map(data => new PaymentType(data));
    // eslint-disable-next-line no-restricted-syntax
    for (const index in paymentMethods) {
      if (paymentMethods[index].id === 4 && paymentMethods[index].references && paymentMethods[index].references.every(x => x.code !== '1199')) {
        paymentMethods[index].references.push({ id: 521, code: '1199', name: 'VISA' });
        paymentMethods[index].references.push({ id: 522, code: '1199', name: 'MASTERCARD' });
      }
    }
    return paymentMethods;
  }
}

export { PaymentTypeController };



// WEBPACK FOOTER //
// ./src/networking/controllers/PaymentTypeController.js